var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class TextureLibrary {
    constructor(textureLoader) {
        this.textureLoader = textureLoader;
        this.texturesById = {};
        this.specsById = {};
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.texturesById[id]) {
                return this.texturesById[id];
            }
            const spec = this.specsById[id];
            if (!spec) {
                throw new Error(`Cannot find texture "${id}" in a library`);
            }
            const texture = yield this.textureLoader.load(spec.file);
            if (!texture) {
                throw new Error(`Cannot find texture with id "${spec.id}"`);
            }
            return texture;
        });
    }
    addTextures(textures) {
        for (const texture of textures) {
            this.specsById[texture.id] = texture;
        }
    }
}
//# sourceMappingURL=TextureLibrary.js.map